import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import { Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function StoreDocumntationTableData(users, handleEditClick, fetchUsers) {
  const [isActive, setIsActive] = useState(true);
  const [loadingDocId, setLoadingDocId] = useState(null); // لتتبع حالة التحميل لكل وثيقة
  const navigate = useNavigate();

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    // التحقق من الصلاحيات أولًا
    if (user.type === "administrator") {
      Swal.fire({
        icon: "error",
        title: "غير مسموح!",
        text: "صلاحيات الحذف مقصورة على المشرفين",
        confirmButtonText: "حسنًا",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      return;
    }

    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المستخدم "${user.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/administrator/store-documents/delete/${user.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المستخدم بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    if (user.type == "administrator") {
      Swal.fire({
        icon: "error",
        title: "فشل تحديث حالة المستخدم",
        text: "ليس لديك صلاحية تعديل حالة المسؤول",
      });
      return;
    }
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/administrator/users/active/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة المستخدم بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name, business_name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar
        src={image}
        name={name}
        size="sm"
        sx={{
          // 1. الخلفية الرمادية عند عدم وجود صورة
          backgroundColor: !image ? "grey.300" : "rgba(0, 0, 0, 0)",
          // 2. تحديد الحجم الجديد
          width: 40,
          height: 40,
          // 3. التأكد من الشكل الدائري
          borderRadius: "50%",
          // 4. تنسيق محتوى الأيقونة
          "& .MuiSvgIcon-root": {
            fontSize: "1rem", // تكبير حجم الأيقونة
          },
        }}
      >
        {!image && <PersonIcon fontSize="small" />}
      </MDAvatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          اسم المتجر: {name}
        </MDTypography>
        <MDTypography variant="caption">اسم السجل التجاري: {business_name}</MDTypography>
      </MDBox>
    </MDBox>
  );

  // دالة قبول/رفض الوثيقة
  const handleDocumentStatus = async (docId, status) => {
    const statusText = status === 2 ? "قبول" : "رفض";
    try {
      setLoadingDocId(docId);
      const token = localStorage.getItem("user-token");
      Swal.fire({
        title: `جاري إرسال طلب ${statusText} الوثيقة...`,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      console.log(docId, status);
      const response = await axios.get(
        `${BASE_URL}/administrator/store-documents/status/${docId}/${status}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: `تم ${statusText} الوثيقة!`,
          text: `تم ${statusText} الوثيقة بنجاح`,
        });
        fetchUsers();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: `فشل ${statusText} الوثيقة!`,
        text: error.response?.data?.message || error.message || "حدث خطأ أثناء العملية",
      });
    } finally {
      setLoadingDocId(null);
    }
  };

  // تحويل أرقام الحالة إلى نصوص عربية
  const statusText = {
    1: "تحت المراجعة",
    2: "مقبولة",
    3: "مرفوضة",
  };

  // const Status = ({ isActive }) => (
  //   <MDBox ml={-1}>
  //     <MDBadge
  //       badgeContent={isActive ? "مفعل" : "غير مفعل"}
  //       color={isActive ? "success" : "dark"}
  //       variant="gradient"
  //       sx="larg"
  //     />
  //   </MDBox>
  // );

  return {
    columns: [
      { Header: "الاسم", accessor: "author", width: "30%", align: "left" },
      { Header: "تاريخ انتهاء الوثائق", accessor: "documents_dates", align: "left" },
      { Header: "الحالة", accessor: "status", align: "left" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: users.map((user) => ({
      author: (
        <Author
          name={user.store.name_ar}
          business_name={user.business_name}
          image={user.store.logo ? user.store.logo : null}
        />
      ),
      store: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {user.store_id || "--"}
        </MDTypography>
      ),
      documents_dates: (
        <Box>
          <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
            ينتهي السجل التجاري في: {user.cr_expiry_date ? user.cr_expiry_date.split(" ")[0] : "--"}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
            ينتهي سجل رخصة البلدية في:{" "}
            {user.municipal_license_expiry ? user.municipal_license_expiry.split(" ")[0] : "--"}
          </MDTypography>
        </Box>
      ),
      status: (
        <MDBadge
          badgeContent={statusText[user.status] || user.status}
          color={user.status == 1 ? "warning" : user.status == 2 ? "success" : "error"}
        />
      ),
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(user)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(user)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>

          {/* زر القبول */}
          <IconButton
            aria-label="قبول الوثيقة"
            sx={{
              color: "success.main",
            }}
            disabled={loadingDocId === user.id}
            onClick={() => handleDocumentStatus(user.id, 2)}
          >
            <CheckCircleIcon fontSize="medium" />
          </IconButton>

          {/* زر الرفض */}
          <IconButton
            aria-label="رفض الوثيقة"
            sx={{
              color: "warning.main",
            }}
            disabled={loadingDocId === user.id}
            onClick={() => handleDocumentStatus(user.id, 3)}
          >
            <CancelIcon fontSize="medium" />
          </IconButton>

          {/* أيقونة المعاينة */}
          <IconButton
            aria-label="preview"
            sx={{ color: "primary.main" }}
            onClick={() => navigate(`/storeDocumntation/preview/${user.id}`)}
          >
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
